"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadStations = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _redux = require("../util/redux.js");

var _fn = require("../util/fn.js");

var _store = require("../l10n/store.js");

var _store2 = require("./store.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var loadStations = function loadStations(contractTypes) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(dispatch, getState, context) {
      var currentLocale, cacheKey;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currentLocale = (0, _store.getCurrentLocale)(getState());
              cacheKey = contractTypes.join(",");
              _context3.next = 4;
              return dispatch((0, _redux.asyncAction)({
                ifPredicate: (0, _fn.not)((0, _store2.areStationsLoaded)(cacheKey)),
                typePrefix: "STATIONS/STATIONS",
                loadPayload: function () {
                  var _loadPayload = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                    var stations;
                    return _regenerator["default"].wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return context.api.stations.getStations({
                              contractTypes: contractTypes
                            });

                          case 2:
                            stations = _context2.sent;
                            _context2.next = 5;
                            return Promise.all(stations.map( /*#__PURE__*/function () {
                              var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(station) {
                                var stationId, bookingRulesParameters, _yield$Promise$all, _yield$Promise$all2, openingTimes, bookingRules;

                                return _regenerator["default"].wrap(function _callee$(_context) {
                                  while (1) {
                                    switch (_context.prev = _context.next) {
                                      case 0:
                                        stationId = station.id;
                                        bookingRulesParameters = contractTypes.length > 1 ? {
                                          stationId: stationId
                                        } : {
                                          stationId: stationId,
                                          contractType: contractTypes[0]
                                        };
                                        _context.next = 4;
                                        return Promise.all([context.api.stations.getStationOpeningTimes({
                                          stationId: stationId
                                        }), context.api.stations.getStationBookingRules(bookingRulesParameters)]);

                                      case 4:
                                        _yield$Promise$all = _context.sent;
                                        _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2);
                                        openingTimes = _yield$Promise$all2[0];
                                        bookingRules = _yield$Promise$all2[1];
                                        return _context.abrupt("return", _objectSpread(_objectSpread({}, station), {}, {
                                          openingTimes: openingTimes,
                                          bookingRules: bookingRules
                                        }));

                                      case 9:
                                      case "end":
                                        return _context.stop();
                                    }
                                  }
                                }, _callee);
                              }));

                              return function (_x4) {
                                return _ref2.apply(this, arguments);
                              };
                            }()));

                          case 5:
                            _context2.t0 = _context2.sent;
                            _context2.t1 = cacheKey;
                            _context2.t2 = currentLocale;
                            return _context2.abrupt("return", {
                              stations: _context2.t0,
                              cacheKey: _context2.t1,
                              locale: _context2.t2
                            });

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  function loadPayload() {
                    return _loadPayload.apply(this, arguments);
                  }

                  return loadPayload;
                }()
              }));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.loadStations = loadStations;